"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StarRating = void 0;
var React = require("react");
var StarRating = /** @class */ (function (_super) {
    __extends(StarRating, _super);
    function StarRating(props) {
        var _this = _super.call(this, props) || this;
        _this.yeses = [];
        _this.nayes = [];
        for (var i = 0; i < 5; i++)
            if (i < _this.props.ratingInfo.rating)
                _this.yeses.push(i);
            else
                _this.nayes.push(i);
        return _this;
    }
    StarRating.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "p-2 d-flex flex-row" },
                React.createElement("span", { className: "lead text-right pr-1", style: { width: '100px' } }, this.props.ratingInfo.title),
                this.yeses.map(function (val, index) {
                    return (React.createElement("span", { key: index, className: "badge badge-warning rounded-circle m-1", style: { width: '20px' } }, " \u00A0 "));
                }),
                this.nayes.map(function (val, index) { return (React.createElement("span", { key: index, className: "badge badge-secondary rounded-circle m-1", style: { width: '20px' } }, " \u00A0 ")); }))));
    };
    ;
    return StarRating;
}(React.PureComponent));
exports.StarRating = StarRating;
//# sourceMappingURL=StarRating.js.map